'use client'
import {
  __spreadProps,
  __spreadValues
} from "./chunk-BBBOZKTU.mjs";

// src/calendar/CalendarIcon.tsx
import { jsx } from "react/jsx-runtime";
var CalendarIcon = (props) => {
  return /* @__PURE__ */ jsx(
    "svg",
    __spreadProps(__spreadValues({
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M2 2H14V14H2V2ZM3.33333 3.33333V4.66667H12.6667V3.33333H3.33333ZM12.6667 6H3.33333V12.6667H12.6667V6ZM4.66667 7.33333H6.00667V8.66667H4.66667V7.33333ZM7.33333 7.33333H8.67333V8.66667H7.33333V7.33333ZM10 7.33333H11.34V8.66667H10V7.33333ZM4.66667 10H6.00667V11.3333H4.66667V10ZM7.33333 10H8.67333V11.3333H7.33333V10Z",
          fill: "currentColor"
        }
      )
    })
  );
};

// src/calendar/CalendarClockIcon.tsx
import { jsx as jsx2 } from "react/jsx-runtime";
var CalendarClockIcon = (props) => {
  return /* @__PURE__ */ jsx2(
    "svg",
    __spreadProps(__spreadValues({
      width: "16",
      height: "17",
      viewBox: "0 0 16 17",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */ jsx2(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10.3272 2.53897C10.4358 2.61503 10.5098 2.73113 10.5328 2.86173L10.9406 5.17457C13.3905 5.31636 15.3334 7.34795 15.3334 9.83333C15.3334 12.4107 13.244 14.5 10.6667 14.5C9.0743 14.5 7.66818 13.7024 6.82603 12.4849L2.71102 13.2105C2.58042 13.2335 2.44603 13.2038 2.33741 13.1277C2.22878 13.0516 2.15482 12.9355 2.13179 12.8049L0.684722 4.59821C0.661695 4.46761 0.691489 4.33322 0.76755 4.22459C0.843611 4.11597 0.959708 4.04201 1.0903 4.01898L9.95357 2.45615C10.0842 2.43312 10.2186 2.46291 10.3272 2.53897ZM6.32877 11.5572C6.11666 11.0239 6.00004 10.4422 6.00004 9.83333C6.00004 8.6707 6.42521 7.60737 7.12854 6.79033L2.23871 7.65254L3.02977 12.1389L6.32877 11.5572ZM2.06506 6.66773L8.74655 5.4896C8.81455 5.47761 8.88176 5.47998 8.94507 5.49451C9.25934 5.3697 9.59039 5.27805 9.93388 5.22387L9.63482 3.52778L1.75635 4.91696L2.06506 6.66773ZM10.6667 6.16667C8.64167 6.16667 7.00004 7.80829 7.00004 9.83333C7.00004 11.8584 8.64167 13.5 10.6667 13.5C12.6918 13.5 14.3334 11.8584 14.3334 9.83333C14.3334 7.80829 12.6918 6.16667 10.6667 6.16667ZM10.6667 7.83333C10.9429 7.83333 11.1667 8.05719 11.1667 8.33333V9.62623L12.3536 10.8131C12.5489 11.0084 12.5489 11.325 12.3536 11.5202C12.1583 11.7155 11.8418 11.7155 11.6465 11.5202L10.3132 10.1869C10.2194 10.0931 10.1667 9.96594 10.1667 9.83333V8.33333C10.1667 8.05719 10.3906 7.83333 10.6667 7.83333Z",
          fill: "currentColor"
        }
      )
    })
  );
};

// src/calendar/Duration.tsx
import { jsx as jsx3, jsxs } from "react/jsx-runtime";
var Duration = (props) => /* @__PURE__ */ jsxs(
  "svg",
  __spreadProps(__spreadValues({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: [
      /* @__PURE__ */ jsx3("g", { clipPath: "url(#clip0_7825_18631)", children: /* @__PURE__ */ jsx3(
        "path",
        {
          clipRule: "evenodd",
          d: "M15.6744 2.80859L16.4156 7.01197C16.6012 7.02319 16.7879 7.04184 16.9753 7.06818C20.8037 7.60622 23.471 11.1459 22.933 14.9743C22.3949 18.8026 18.8552 21.47 15.0269 20.9319C13.0113 20.6487 11.3176 19.5334 10.244 17.9821L3.33336 19.2006L0.902283 5.41332L15.6744 2.80859ZM9.32592 16.1131C9.01912 15.1463 8.9186 14.0974 9.0692 13.0258C9.23754 11.828 9.69971 10.7439 10.3726 9.836L3.91379 10.9749L4.95568 16.8837L9.32592 16.1131ZM3.56649 9.00525L14.3994 7.09512L14.0521 5.12551L3.21919 7.03564L3.56649 9.00525ZM16.6969 9.04871C13.9624 8.6644 11.434 10.5696 11.0497 13.3042C10.6654 16.0387 12.5707 18.5671 15.3052 18.9514C18.0398 19.3357 20.5681 17.4305 20.9524 14.6959C21.3367 11.9614 19.4315 9.43303 16.6969 9.04871ZM17.4089 11.1684L17.049 13.729L18.82 16.0793L17.2227 17.2829L14.9532 14.2711L15.4283 10.8901L17.4089 11.1684Z",
          fill: "currentColor"
        }
      ) }),
      /* @__PURE__ */ jsx3("defs", { children: /* @__PURE__ */ jsx3("rect", { width: "24", height: "24", fill: "currentColor" }) })
    ]
  })
);

// src/calendar/SimpleCalendar.tsx
import { jsx as jsx4 } from "react/jsx-runtime";
var SimpleCalendar = (props) => {
  return /* @__PURE__ */ jsx4(
    "svg",
    __spreadProps(__spreadValues({
      width: "24",
      height: "25",
      viewBox: "0 0 24 25",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */ jsx4(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9 2.69092V4.69092H15V2.69092H17V4.69092H21V21.6909H3V4.69092H7V2.69092H9ZM5 6.69092V9.69092H19V6.69092H5ZM19 11.6909H5V19.6909H19V11.6909Z",
          fill: "currentColor"
        }
      )
    })
  );
};

export {
  CalendarIcon,
  CalendarClockIcon,
  Duration,
  SimpleCalendar
};
//# sourceMappingURL=chunk-R42EB2AX.mjs.map